import { render, staticRenderFns } from "./criminalRecords.vue?vue&type=template&id=439b91e0&scoped=true"
import script from "./criminalRecords.vue?vue&type=script&lang=js"
export * from "./criminalRecords.vue?vue&type=script&lang=js"
import style0 from "./criminalRecords.vue?vue&type=style&index=0&id=439b91e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439b91e0",
  null
  
)

export default component.exports